import { request } from './http';
import type { OrderPreference } from '../domain/types';

type PreferencesEnvelope = {
  data?: OrderPreference[];
  Data?: OrderPreference[];
};

// GET /order/catalog/preferences — additional services (child seat, pet, courier,
// etc.). Mirrors flutter_client getPreferences() → OrderPreferenceOption. The
// backend wraps the list in SmartTaxiResponse { data } (camelCase).
export async function getPreferences(): Promise<OrderPreference[]> {
  const res = await request<PreferencesEnvelope>('/order/catalog/preferences');
  return res.data ?? res.Data ?? [];
}
